import { FC } from 'react';
import { Event, Views } from 'react-big-calendar';
import { format } from 'date-fns';

import { CampaignSlot } from 'src/api/campaigns/types';
import styles from './event.module.css';

interface CampaignEvent extends Event {
  slot: CampaignSlot;
}

interface CustomEventProps {
  event: Event;
  currentView?: string;
  slotStart?: Date;
  slotEnd?: Date;
}

export const CustomEvent: FC<CustomEventProps> = ({ event, currentView }) => {
  const campaignEvent = event as CampaignEvent;

  const deviceName = campaignEvent.slot.device.name;
  const interactionName = campaignEvent.slot.interaction.name;
  const brandingName = campaignEvent.slot.branding.name;

  const isDayView = currentView === Views.DAY;
  const isMonthView = currentView === Views.MONTH;

  const timeRange =
    isDayView && event.start && event.end
      ? `${format(event.start, 'HH:mm')} - ${format(event.end, 'HH:mm')}`
      : null;

  return (
    <div className={styles.customEvent}>
      <span className={styles.title}>{campaignEvent.slot.name}</span>
      {isDayView && timeRange && (
        <>
          <br /> <span className={styles.timeRange}> {timeRange}</span>
        </>
      )}

      {!isMonthView && (
        <>
          <br />
          <br />
          Device: <span className={styles.value}>{deviceName}</span>
          <br />
          Interaction: <span className={styles.value}>{interactionName}</span>
          <br />
          Branding: <span className={styles.value}>{brandingName}</span>
        </>
      )}
    </div>
  );
};
